type ExtractFromUnionByTypename<T, TypeName> = T extends {
  __typename?: TypeName;
}
  ? T
  : never;

export const filterByTypename = <
  Union extends { __typename?: string },
  K extends string
>(
  elements: Union[],
  typename: K,
): ExtractFromUnionByTypename<Union, K>[] => {
  return elements.filter(e => e.__typename === typename) as any;
};
